var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ve-line',{attrs:{"data":{rows: _vm.data},"settings":_vm.computedSettings,"height":_vm.height,"grid":_vm.grid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }